<template>
    <div style="display: none;">
        <slot v-if="ready"></slot>
    </div>
</template>

<script>
import L, { DomEvent } from 'leaflet';
import { findRealParent, propsBinder } from 'vue2-leaflet';
import "leaflet.locatecontrol";
import { dom } from '@fortawesome/fontawesome-svg-core'

const props = {
  fineGeo: Boolean,
  options: {
    type: Object,
    default() {
      return {
        //setView: false,
        //clickBehavior: {inView: 'stop', outOfView: 'stop' },
        setView: 'untilPan',
        keepCurrentZoomLevel: true,
        locateOptions: { enableHighAccuracy: this.fineGeo },  // this.fineGeo
        strings: {title: this.$t('FIND_ME') },

      };
    },
  },
  visible: {
    type: Boolean,
    custom: true,
    default: true
  }
}
export default {
  name: "Vue2LeafletLocatecontrol",
  props: props,
  data() {
    return {
      ready: false
    }
  },
  beforeDestroy() {
    this.parentContainer.removeLayer(this);
  },
  mounted() {
    //alert(this.fineGeo);
    this.mapObject = L.control.locate(this.options);
/*
    this.mapObject = L.control.locate({
       locateOptions: {
               enableHighAccuracy: true
        }
    });
*/
    DomEvent.on(this.mapObject, this.$listeners);
    propsBinder(this, this.mapObject, props);
    this.ready = true;
    this.parentContainer = findRealParent(this.$parent);
    this.mapObject.addTo(this.parentContainer.mapObject, !this.visible);
    dom.i2svg();
  }
}
</script>

<style>
@import "~leaflet.locatecontrol/dist/L.Control.Locate.css";

 .loct {
    background-image:
    url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxMCcgaGVpZ2h0PScxMCc+PGxpbmVhckdyYWRpZW50IGlkPSdncmFkaWVudCc+PHN0b3Agb2Zmc2V0PScxMCUnIHN0b3AtY29sb3I9JyNGMDAnLz48c3RvcCBvZmZzZXQ9JzkwJScgc3RvcC1jb2xvcj0nI2ZjYycvPiA8L2xpbmVhckdyYWRpZW50PjxyZWN0IGZpbGw9J3VybCgjZ3JhZGllbnQpJyB4PScwJyB5PScwJyB3aWR0aD0nMTAwJScgaGVpZ2h0PScxMDAlJy8+PC9zdmc+");

  /* background-image: url(happy.svg); */

  /*
  background: url("data:image/svg+xml;base64,[<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500">
<path fill="none" stroke="#000" stroke-width="6" d="m250,38 108,212-108,212-108-212z"/>
</svg>]");
*/
}

</style>